import * as React from 'react';
import { Helmet } from 'react-helmet';
import { truncate } from '../../../utils/string';

export interface SiteMetaProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
}

export interface SiteMetaState {
  /* empty */
}

const DEFAULT_DESCRIPTION =
  'Edge of Play is an online resource providing hundreds of soccer ' +
  'coaching videos, downloadable session plans and other complimentary ' +
  'resources to use in your training sessions.';

const DEFAULT_TITLE = 'Edge of Play';

const BASE_URL = `https://edgeofplay.com`;

const EDGE_OF_PLAY_FACEBOOK_ID = '1838771493017384';

export class SiteMeta extends React.Component<SiteMetaProps, SiteMetaState> {
  render() {
    const {
      title = DEFAULT_TITLE,
      description = DEFAULT_DESCRIPTION,
      image,
      url = ''
    } = this.props;

    return (
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={truncate(description, 155)} />

        {/* Twitter Card data */}
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@edgeofplay" />
        <meta name="twitter:creator" content="@edgeofplay" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={truncate(description, 200)} />
        {image ? <meta name="twitter:image" content={image} /> : null}

        {/* Open Graph data */}
        <meta property="og:type" content="article" />
        <meta property="og:site_name" content="Edge of Play" />
        <meta property="fb:admins" content={EDGE_OF_PLAY_FACEBOOK_ID} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={`${BASE_URL}${url}`} />
        {image ? <meta property="og:image" content={image} /> : null}
      </Helmet>
    );
  }
}

export default SiteMeta;



// WEBPACK FOOTER //
// ./src/app/components/Utils/SiteMeta/index.tsx